
(async () => {

  const fetchTopPandas = async () => {
    try { 
      const response = await axios.get('https://api.pandastats.io/pandas/leaderboard');

      if (response.status === 200) {       
        const owner_pandas = response.data;

        const divNames = ['#top-aliens-table', '#top-zombies-table', '#top-golds-table', '#top-normals-table'];

        divNames.forEach((divName, index) => {
          const traitIdFilter = getTraitIdFilter(index + 1); // Adjust index to start from 1
          const filteredData = filterByTraitId(owner_pandas, traitIdFilter);

          $(divName).DataTable({
              order: [[2, 'asc']],
              data: filteredData,
              searching: false,
              paging: false,
              info: false,
              sort: false,
              "bLengthChange": false,
              "pageLength": 10,
              columns: [
                {
                  title: "#",
                  data: null,
                  className: "dt-body-center pe-0 fw-bold",
                  orderable: false,
                  style: "font-weight: bold;",
                  render: function (data, type, row, meta) {
                    return meta.row + 1;
                  },
                },
                  { title: '', data: 'Id', orderable: false, className: 'dt-body-left px-0',
                    render: function (data, type, row, meta) {
                      return type === 'display'
                      ? '<img src="https://prodftpserver.blob.core.windows.net/images/default/' + data + '-1000x1000?r=' + Math.floor(Math.random() * 100000) + '" width="50px" data-bs-toggle="tooltip" data-bs-id="' + row.Id + '" data-bs-placement="top" data-tooltip="<div><img src=\'https://prodftpserver.blob.core.windows.net/images/default/' + data + '-1000x1000?r=' + Math.floor(Math.random() * 100000) + '\' width=\'150px\'/></div>" data-bs-html="true" />'
                      : data;
                    },
                  },
                  { title: 'Id', data: 'Id', className: 'dt-body-left px-0',
                    render: function (data, type, row, meta) {
                      return type === 'display'
                          ? '<a href="panda.html?id=' + data + '">' + data + '</a>'
                          : data;
                    },
                  },
                  { title: 'Rank', data: 'Rank', className: 'dt-body-left px-0'},
                  { title: 'Owner', data: 'Owner', className: 'dt-body-left px-0',
                    render: function (data, type, row, meta) {
                      if (!data) {
                        return '-';
                      }

                      const owner_displayname = row.OwnerEnsName ? row.OwnerEnsName : data.substring(0,5);
                      return type === 'display'
                          ? '<a href="profile.html?address=' + data + '">' + owner_displayname + '</a>'
                          : data;
                    },
                  }
                  
              ],
              initComplete: function () {
                createTooltips(divName);
              },
              drawCallback: function() {
                createTooltips(divName);
              }
          });

        });
      } else {
        console.error('Error fetching data:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  function getTraitIdFilter(index) {
    // Map index to corresponding trait ID
    switch(index) {
      case 1: return 306; // top-aliens-table
      case 2: return 305; // top-zombies-table
      case 3: return 302; // top-golds-table
      case 4: return [303, 304]; // top-normals-table
      default: return null;
    }
  }

  function filterByTraitId(data, traitIdFilter) {
    // Check if traitIdFilter is an array
    if (Array.isArray(traitIdFilter)) {
      return data.filter(panda => traitIdFilter.includes(panda.TraitId));
    } else {
      return data.filter(panda => panda.TraitId === traitIdFilter);
    }
  }

  function createTooltips(divName) {
    const tooltips = $(divName).find('[data-bs-id]');
  
    tooltips.each(function () {
      const content = $(this).attr('data-tooltip');
      const id = $(this).attr('data-bs-id');
  
      $(this).attr('data-bs-html', true);
      new bootstrap.Tooltip(this, {
        id: id,
        placement: 'top',
        html: true,
        sanitizeFn: (content) => content,
        title: content
      });
    });
  }

  fetchTopPandas();

})();